
// Height JS For Style View
import $ from 'jquery';

$(document).ready(function () {
      
   
    $('.activities-card-height').css({
        'height': $('.card-container-height').innerHeight()
    });

});

$(document).ready(function () {
    $(document).on('click', 'a.changeselecteds', function (event) {
      event.preventDefault();
        
        $('.left-nav li').find('.selected').removeClass('selected');
        var $parent = $(this);
        $parent.addClass('selected');
        
    });
});



// JS for Filter Click
$(document).ready(function () {
    $(document).on('click', '.click-me', function () {
            $(".customer-filter").toggle("slow");
            $(".supplier-filter").toggle("slow");
    });
});

// JS For Reference Add Image
$(document).ready(function () {
    $('.clickme').click(
        function () {
            $('.upload-box').toggle(500);
            return false;
        }
    );
    $('.clickme1').click(
        function () {
            $('.upload-box1').toggle(500);
            return false;
        }
    );
});

// Dynamic Change On Customer-Edit, Supplier-Edit, Manage-Fabric-Edit, Manage-Trims-Edit JS Starts Here
$(document).ready(function () {
    $(".site-add").click(function () {
        $(this).parent().parent().parent().parent().parent().find(".add-site").fadeIn('fast');
        $(this).parent().parent().parent().parent().parent().find('.hide-customer-site').hide();
        return false;
    });

    $(".site-add-go-back").click(function () {
        $(".add-site").hide();
        $('.hide-customer-site').fadeIn('fast');
        return false;
    });

    $(".dept-add").click(function () {
        $(".add-dept").fadeIn('fast');
        $('.hide-customer-dept').hide();
        return false;
    });

    $(".dept-add-go-back").click(function () {
        $(".add-dept").hide();
        $('.hide-customer-dept').fadeIn('fast');
        return false;
    });

    // Image Edit JS Starts Here
    $(".edit-img").click(function () {
        $(this).parent().parent().parent().parent().parent().parent().parent().parent().parent().find(".edit-site").fadeIn('fast');
        $(this).parent().parent().parent().parent().parent().parent().parent().parent().parent().find('.hide-customer-site').hide();
        return false;
    });

    $(".site-add-go-back").click(function () {
        $(".edit-site").hide();
        $('.hide-customer-site').fadeIn('fast');
        return false;
    });

    $(".edit-img1").click(function () {
        $(".edit-site1").fadeIn('fast');
        $('.hide-customer-site1').hide();
        return false;
    });

    $(".site-add-go-back1").click(function () {
        $(".edit-site1").hide();
        $('.hide-customer-site1').fadeIn('fast');
        return false;
    });

});

// Material Selector on ADD Materials JS Starts Here
$(function () {
    $('#material-selector').change(function () {
        $('.materials').hide();
        $('#' + $(this).val()).show();
    });
    $(".site-add-go-back").click(function () {
        $(".materials").hide();
        $('.hide-customer-site').fadeIn('fast');
        return false;
    });

    $('#attribute-selector').change(function () {
        $('#' + $(this).val()).show();
    });

    $('#dye-selector').change(function () {
        $('#' + $(this).val()).show();
    });

    $('#style-selector').change(function () {
        $('.materials').hide();
        $('#' + $(this).val()).show();
    });

    $('#fabric-ib').change(function () {
        $('.fabric').hide();
        $('#' + $(this).val()).show();
    });

    $('#devType-selec').change(function () {
        $('.development').hide();
        $('#' + $(this).val()).show();
    });

    $('#sealer-selec').change(function () {
        $('.sealer-yard').hide();
        $('#' + $(this).val()).show();
    });

});

$(document).ready(function () {
    $(".option-open").click(function () {
        $(".option-con").toggle(100);
        return false;
    });
    $(".add-options").click(function () {
        $(".options-con-open").show();
        return false;
    });
});

$(document).ready(function () {
    $(".addIB_Order").click(function () {
        $(this).parent().parent().parent().parent().find(".ib-order").show();
        return false;
    });
});

$(document).ready(function () {
    $(".addIB_Shipment").click(function () {
        $(this).parent().parent().parent().parent().find(".ib-shipment").show();
        return false;
    });
});

$(document).ready(function () {
    $(".sec-close-btn").click(function () {
        $(this).parent().parent().parent().parent().find(".second-address-con").hide();
        return false;
    });

    $(".row-add-btn").click(function () {
        $(".row-address-con").show();
        return false;
    });
    $(".row-close-btn").click(function () {
        $(".row-address-con").hide();
        return false;
    });

    $(".wash-add-btn").click(function () {
        $(".wash-address-con").show();
        return false;
    });
    $(".-close-btn").click(function () {
        $(".row-address-con").hide();
        return false;
    });

});

// Department radio on click Change JS Starts here
$(document).ready(function () {
    $(':radio').change(function (event) {
        var id = $(this).data('id');
        $('#' + id).addClass('none').siblings().removeClass('none');
    });
});

//Rights JS STARTS HERE
$(document).ready(function () {
    // Custom Check-Box
    $('#check-all').click(function (event) {
        if (this.checked) {
            $(':checkbox').each(function () {
                this.checked = true;
            });
        } else {
            $(':checkbox').each(function () {
                this.checked = false;
            });
        }
    });

    // Pattern JS

    $(".open-box").click(function () {
        $(this).parent().parent().find(".show-box").toggle(200);
    });

    $(".clones").click(function () {
        $(".comparison-con").css("display", "block");
        $(".clear-close").click(function () {
            $(".comparison-con").css("display", "none");
        });
    });
});



/*PRASUN*/

$(document).ready(function () {
    var NumberOfDept = 0;
    $(document).on('click', '.clone-box', function () {
        var id = this.id.substr(9, 1);
        
        var num = $('.size-select-div' + id).length;
        
        var newNum = new Number(num + 1);
        
        var NewSelectBox = $("#size-select-div" + id + ":last").clone().attr('id', 'size-select-div' + id + '-' + newNum).appendTo("#multiple-clone-box" + id);
        NewSelectBox.find("#size-select").attr('id', 'size-select' + id + '-' + newNum);
        NewSelectBox.find("#remove-box").attr('id', 'remove-box' + id + '-' + newNum);
        NewSelectBox.find(".clone-box").remove();
        NewSelectBox.find(".remove-box").show();

        $("#size-show-box" + id + "-" + newNum).show();
        $("#remove-box" + id + "-" + newNum).show();
        
    });

    //SELECT SIZE CHANGE
    $(document).on('change', '.size-select', function () {
        var id = this.id.substr(11, 1);
        
        var selected_option = $("#size-select" + id).val();
        $("#size-select" + id + ":selected").attr('disabled', 'disabled').siblings().removeAttr('disabled');
        
        $(this).parent().parent().parent().parent().parent().find('#size-updater').append($('<li>').append(selected_option + '<span className="clear-size"><i className="material-icons">clear</i></span>')).trigger('create');
        //$('#size-updater').append($('<li>').append('A<span className="clear-size"><i className="material-icons">clear</i></span>')).trigger('create');
    });
    var abc = ' <li>M <span className="clear-size"><i className="material-icons">clear</i></span></li>';

    $(document).on('click', '.add-qty-btn', function () {
        var id = this.id.substr(11, 1);
        
        var num = $('.qty-box' + id).length;
        
        var newNum = new Number(num + 1);
        var NewQtyBox = $("#qty-box" + id + ":last").clone().attr('id', 'qty-box-div' + id + '-' + newNum).appendTo("#multiple-qty-box" + id);
        NewQtyBox.find("select").css({ "width": "76px", "float": "left" });
        NewQtyBox.find(".del-qty-box").show();
        //NewQtyBox.find(".del-qty-box").attr('id', 'del-qty-box'+id+'-'+newNum);
    })

    $(document).on('click', '.del-qty-box', function () {
        $(this).parent().remove()
    });

    //Shipping Box
    $(document).on('click', '.add-shipping-btn', function () {
        var id = this.id.substr(16, 1);
        
        var num = $('.shipping-box' + id).length;
        var newNum = new Number(num + 1);
        
        var NewShippingBox = $("#shipping-box:last").clone().attr('id', 'shipping-box' + id + '-' + newNum).appendTo("#multiple-shipping-box" + id);
        NewShippingBox.find('select').css({ "float": "left", "width": "180px", "margin-right": "15px", "margin-top": "15px" })
        NewShippingBox.find(".del-shipping-box").show();
        NewShippingBox.find(".add-shipping-btn").remove();
        NewShippingBox.find(".del-shipping-box").css({ "margin-top": "13px" })
        //
    });

    $(document).on('click', '.del-shipping-box', function () {
        $(this).parent().parent().parent().remove()
    });

    $(document).on('click', '.add-staff-btn', function () {
        var id = this.id.substr(13, 1);
        
        var num = $('.staff-box' + id).length;
        var newNum = new Number(num + 1);
        
        var NewStaffBox = $("#staff-box:last").clone().attr('id', 'staff-box' + id + '-' + newNum).appendTo("#multiple-staff-box" + id);
        NewStaffBox.find("input").val('');
        NewStaffBox.find(".del-staff-btn").show();
        NewStaffBox.find(".add-staff-btn").hide();
    });


    $(document).on('click', '.del-staff-btn', function () {
        $(this).parent().parent().parent().remove()
    });


    /*ADDING EMPLOYEE PIC USING FA ICONS */
    $(document).on('click', '.input-file-i', function () {
        
        $(this).parent().parent().find(".input-file").trigger('click');
    })

    $(document).on('click', '.add-shipping-info-btn', function () {
        var id = $('.shipping-info-box').length;
        var newNum = new Number(id + 1);
        
        var NewShippingBox = $("#shipping-info-box:last").clone().attr('id', 'shipping-info-box' + newNum).appendTo("#multiple-shipping-info-box");
        NewShippingBox.find(".del-shipping-info-box").attr('id', 'del-customer-info-btn' + newNum);
        NewShippingBox.find('input').val('');
        NewShippingBox.find('textarea').val('');
        NewShippingBox.find(".del-shipping-info-box").show();
        NewShippingBox.find(".add-shipping-info-btn").hide();
    })

    $(document).on('click', '.del-shipping-info-box', function () {
        $(this).parent().parent().parent().remove()
    });

    $('.scroll-up-btn').click(function () {
        $('html, body').animate({ scrollTop: 0 }, 'slow');
    });


    //COSTING EDIT PAGE

    $(document).on('click', '.ratio-costing-add-btn', function () {
        var id = $('.ratio-costing-tr').length;
        var newNum = new Number(id + 1);
        var NewRatioCostingtr = $("#main-ratio-costing-tr").clone().attr('id', 'ratio-costing-tr' + newNum).appendTo("#ratio-costing-tbody");
        NewRatioCostingtr.find("input").val('');
        NewRatioCostingtr.find(".ratio-costing-del-btn").show();
        NewRatioCostingtr.find(".ratio-costing-add-btn").hide();
    });

    $(document).on('click', '.ratio-costing-del-btn', function () {
        $(this).parent().parent().remove();
    });

    $(document).on('click', '.add-item-btn', function () {
        var id = $('.item-box').length;
        
        var newNum = new Number(id + 1);
        var NewItemtr = $("#main-item-box:last").clone().attr('id', 'main-item-box' + newNum).appendTo("#item-box-tbody");
        NewItemtr.show();
        NewItemtr.find(".del-item-btn").show();
    });

    $(document).on('click', '.del-item-btn', function () {
        $(this).parent().parent().remove();
    });

    // FABRIC ADD ITEMS
    $(document).on('click', '.fab-add-item-btn', function () {
        var id = $('.fabric-length').length;
        
        var newNum = new Number(id + 1);
        var NewItemtr = $("#fabric-items-add:last").clone().attr('id', 'fabric-items-add' + newNum).appendTo("#fabric-items");
        NewItemtr.show();
        NewItemtr.find(".fab-del-item-btn").show();
    });

    $(document).on('click', '.fab-del-item-btn', function () {
        $(this).parent().parent().remove();
    });

     // TRIM ADD ITEMS
     $(document).on('click', '.trim-add-item-btn', function () {
        var id = $('.trim-length').length;
        
        var newNum = new Number(id + 1);
        var NewItemtr = $("#trim-items-add:last").clone().attr('id', 'trim-items-add' + newNum).appendTo("#trim-items");
        NewItemtr.show();
        NewItemtr.find(".trim-del-item-btn").show();
    });

    $(document).on('click', '.trim-del-item-btn', function () {
        $(this).parent().parent().remove();
    });

    // Embroidery ADD ITEMS
    $(document).on('click', '.emb-add-item-btn', function () {
        var id = $('.emb-length').length;
        
        var newNum = new Number(id + 1);
        var NewItemtr = $("#emb-items-add:last").clone().attr('id', 'emb-items-add' + newNum).appendTo("#emb-items");
        NewItemtr.show();
        NewItemtr.find(".emb-del-item-btn").show();
    });
    $(document).on('click', '.emb-del-item-btn', function () {
        $(this).parent().parent().remove();
    });

     // Embroidery ADD ITEMS
     $(document).on('click', '.wash-add-item-btn', function () {
        var id = $('.wash-length').length;
        
        var newNum = new Number(id + 1);
        var NewItemtr = $("#wash-items-add:last").clone().attr('id', 'wash-items-add' + newNum).appendTo("#wash-items");
        NewItemtr.show();
        NewItemtr.find(".wash-del-item-btn").show();
    });
    $(document).on('click', '.wash-del-item-btn', function () {
        $(this).parent().parent().remove();
    });

    //SAMPLE REQUEST 

    $(document).on('click', '.sample-opt-chckbox', function () {
        var value = $(this).val();
        
        
        if ($(this).prop("checked")) {
            $("#" + $(this).val()).show();
        } else {
            $("#" + $(this).val()).hide();
        }
    });

    //SAMPLE - ADD SIZE AND QTY MULTIPLE

    //EMBROIDERY ARRAY LIST ON CLICK 
    $(document).on('click', '.embroideryArray1', function () {
        $(this).find('li:first').toggleClass('selected');
    })

    //EMBROIDERY ARRAY LIST 2 
    $(document).on('click', '.embroideryArray2', function () {
        $(this).find('li:first').toggleClass('selected');
    })


    //DISPATCH SIZE
    $(document).on('click', '.add-dispatch-size-btn', function () {
        var id = $('.main-dispatch-size-box').length;
        var newNum = new Number(id + 1);
        var NewRatioCostingtr = $("#main-dispatch-size-box").clone().attr('id', 'main-dispatch-size-box' + newNum).appendTo("#multiple-dispatch-size-box");
        NewRatioCostingtr.find("input").val('');
        NewRatioCostingtr.find(".del-dispatch-size-btn").show();
        NewRatioCostingtr.find(".add-dispatch-size-btn").hide();
    });

    $(document).on('click', '.del-dispatch-size-btn', function () {
        $(this).parent().parent().parent().parent().remove();
    });

});





// WEBPACK FOOTER //
// ./src/assets/js/dashboard.js